export default {
  /* Marketing validations */
  selectmarketing_type: {
    required: "Seleccione tipo de marketing."
  },
  institution_name: {
    required: "Por favor ingrese el nombre de la institución ",
    regex: "Solo se permiten alfabetos, números, guiones y espacios. "
  },

  ot_offer_type: {
    required: "Por favor, introduzca el tipo de oferta",
    regex: "Solo se permiten alfabetos, números,% y espacios "
  },
  bank_name: {
    required: "Por favor ingrese el nombre del banco ",
    regex: "Solo se permiten alfabetos y espacios "
  },
  card_type: {
    required: "Por favor, introduzca el tipo de tarjeta "
  },
  cust_name: {
    required: "Por favor ingrese el nombre del cliente ",
    regex: "Solo se permiten alfabetos y espacios "
  },
  cust_mobile: {
    required: "Por favor, introduzca el número de móvil ",
    numeric: "Solo se permiten números.",
    min: "El número de móvil debe ser mínimo 6.",
    max: "El número de móvil debe ser máximo 15."
  },

  //Vouchers
  voucher_code: {
    required: "El código del cupón no puede estar vacío "
  },
  voucher_title: {
    required: "Por favor, introduzca el nombre del comprobante "
  },
  voucher_datetime: {
    required: "Por favor, introduzca la fecha y hora del comprobante "
  },
  termsandco: {
    required: "Por favor ingrese los términos y condiciones del cupón "
  },
  voucher_amt: {
    required: "Por favor, introduzca el valor del comprobante.",
    numeric: "Solo se permite el valor numérico"
  },
  voucher_min_amt: {
    required: "Por favor ingrese el monto del comprobante  ",
    numeric: "Solo se permite el valor numérico"
  },
  voucher_max_amt: {
    required: "Por favor ingrese el monto del comprobante  ",
    numeric: "Solo se permite el valor numérico"
  },
  buy_ticket: {
    required: "Por favor ingrese el número de boletos de compra.",
    numeric: "Solo se permiten números."
  },
  get_ticket: {
    required: "Por favor, introduzca el número de entradas.",
    numeric: "Solo se permiten números."
  },

  //  DOCUMENT VERIFICATION DETAILS
  vd_document_name: {
    required: "El nombre del documento no puede estar vacío"
  },

  /*Add recipe*/
  qty: {
    required: "Por favor, introduzca la cantidad.",
    decimal: "Solo se permiten decimales y números."
  },

  /* Setup Organization Settings
   */
  concession_level: {
    required: "Por favor ingrese el nivel de concesión",
    regex: "Solo se permiten alfabetos, números y espacios"
  },
  //PurchaseOrderComponent addPurchaseOrder and editPurchaseOrder
  purchasedate: {
    required: "Seleccione la fecha de la orden de compra."
  },
  itemcode: {
    required: "Por favor, introduzca el código del artículo.",
    alpha_num: "Solo se permiten números y alfabéticos."
  },
  totalrate: {
    required: "Por favor ingrese el monto total.",
    decimal: "Solo se permiten números y decimales."
  },
  totalamount: {
    required: "Por favor ingrese el monto total.",
    decimal: "Solo se permiten números y decimales."
  },

  //InvoiceComponent
  invociedate: {
    required: "Por favor seleccione la fecha de la factura."
  },
  rmname: {
    required: "Por favor, introduzca el nombre del artículo."
  },
  itemcode: {
    required: "Por favor, introduzca el código del artículo.",
    alpha_num: "Solo se permiten números y alfabéticos."
  },
  invoicenetamount: {
    required: "Por favor ingrese el monto neto.",
    decimal: "Solo se permiten números y decimales."
  },
  taxamount: {
    required: "Por favor ingrese el monto del impuesto.",
    decimal: "Solo se permiten números y decimales."
  },
  totalamount: {
    required: "Por favor, introduzca la cantidad total.",
    decimal: "Solo se permiten números y decimales."
  },
  finaltotalamount: {
    required: "Por favor, introduzca la cantidad total.",
    decimal: "Solo se permiten números y decimales."
  },

  //UserComponent addUser and editUser same for both.
  firstname: {
    required: "Por favor, introduzca el nombre.*",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },
  middlename: {
    required: "Por favor, introduzca el segundo nombre.",
    regex: "Solo se permiten alfabetos, espacios y -."
  },
  lastname: {
    required: "Por favor, introduzca el apellido.",
    alpha_spaces: "Por favor, introduzca el apellido."
  },
  selectgender: {
    required: "Por favor seleccione el género."
  },
  dob: {
    required: "Por favor seleccione la fecha de nacimiento."
  },
  doj: {
    required: "Por favor, seleccione Fecha de incorporación."
  },
  address: {
    required: "Por favor, introduzca la dirección.",
    regex: "Solo se permiten la barra invertida y la coma.",
    alpha_dash: "Se permiten alfabetos y guiones.",
    alpha_num: "Se permiten alfabetos y números.",
    alpha_spaces: "Se permiten alfabetos y espacios."
  },
  selectcountry: {
    required: "Por favor seleccione país."
  },
  selectstate: {
    required: "Por favor seleccione Estado."
  },
  selectcity: {
    required: "Por favor seleccione Ciudad."
  },
  zipcode: {
    required: "Por favor, introduzca el código postal.",
    numeric: "Solo se permiten números."
  },
  email: {
    required: "Por favor, introduzca su ID de correo electrónico.",
    email:
      "Por favor, introduzca la identificación de correo electrónico correcta"
  },
  phoneno: {
    required: "Por favor, introduzca el número de teléfono.",
    numeric: "Solo se permiten números.",
    min: "El número de teléfono debe ser mínimo 7."
  },
  mobileno: {
    required: "Por favor, introduzca el número de móvil.",
    numeric: "Solo se permiten números.",
    min: "El número de móvil debe ser mínimo 8.",
    max: "El número de móvil debe ser máximo 14."
  },
  username: {
    required: "Por favor, introduzca el nombre de usuario",
    alpha_num: "Solo se permiten alfabetos y números."
  },
  password: {
    required: "Por favor, ingrese contraseña.",
    regex:
      "La contraseña debe tener un mínimo de 8 y un máximo de 16 caracteres."
  },
  selectrole: {
    required: "Por favor seleccione Rol."
  },
  selectdesignation: {
    required: "Por favor seleccione Designación."
  },
  selectcinema: {
    required: "Por favor seleccione Cine."
  },
  employeeid: {
    required: "Por favor, introduzca la identificación del empleado.",
    alpha_num: "Solo se permiten alfabetos y números."
  },
  selectdepartment: {
    required: "Por favor seleccione Departamento."
  },

  //RolesComponent addRoles and editRoles.
  role_name: {
    required: "Por favor, introduzca el nombre del rol.",
    regex: "Solo se permiten alfabetos y números.",
    min: "Por favor ingrese un mínimo de 3 caracteres.",
    max: "Por favor, introduzca un máximo de 20 caracteres."
  },

  //DesignationComponent addDesignation and editDesignation.
  designation: {
    required: "Por favor, introduzca la designación.",
    regex: "Solo se permiten alfabetos, espacios y &.",
    min: "Por favor, introduzca un mínimo de 3 caracteres.",
    max: "Por favor ingrese un máximo de 15 caracteres."
  },

  //DepartmentComponent addDepartment and editDepartment.
  dept_name: {
    required: "Por favor ingrese al departamento.",
    regex: "Solo se permiten alfabetos, espacios y &."
  },
  dept_code: {
    required: "Por favor, introduzca el código del departamento.",
    alpha_num: "Solo se permiten alfabetos y números.",
    min: "Por favor, introduzca un mínimo de 2 caracteres.",
    max: "Por favor ingrese un máximo de 6 caracteres."
  },

  //GenderComponent addGender and editGender.
  gender: {
    required: "Por favor, introduzca género.",
    alpha: "Solo se permiten alfabetos."
  },

  //MaritalStatusesComponent addMaritalStatus and editMaritalStatus.
  ms_name: {
    required: "Por favor, introduzca el estado civil.",
    alpha_spaces: "Solo se permiten alfabetos y espacios.",
    min: "Por favor, introduzca un mínimo de 3 caracteres.",
    max: "Por favor ingrese un máximo de 15 caracteres."
  },

  //StatesComponent addState and editState.
  state_name: {
    required: "Por favor, introduzca el nombre del estado.",
    alpha_spaces: "Solo se permiten alfabetos y espacios.",
    min: "Por favor, introduzca un mínimo de 3 caracteres.",
    max: "Por favor ingrese un máximo de 15 caracteres."
  },
  state_code: {
    required: "Por favor, introduzca el código del estado.",
    alpha_num: "Solo se permiten números.",
    min: "Por favor, introduzca un mínimo de 2 caracteres.",
    max: "Por favor, introduzca un máximo de 10 caracteres."
  },
  country_id: {
    required: "Por favor seleccione país."
  },

  //CountriesComponent addCountry and editCountry.
  country_name: {
    required: "Por favor, introduzca el nombre del país.",
    alpha_spaces: "Solo se permiten alfabetos y espacios.",
    min: "Por favor, introduzca un mínimo de 3 caracteres.",
    max: "Por favor ingrese un máximo de 30 caracteres."
  },
  country_code: {
    required: "Por favor, introduzca el código del país.",
    min: "Por favor, introduzca un mínimo de 2 caracteres.",
    max: "Por favor, introduzca un máximo de 10 caracteres."
  },
  iso_code: {
    required: "Por favor, introduzca el código ISO.",
    min: "Por favor, introduzca un mínimo de 2 caracteres.",
    max: "Por favor, introduzca un máximo de 10 caracteres."
  },
   iso_2: {
  required: "Por favor, introduzca el código ISO 2.",
    min: "Por favor, introduzca un mínimo de 2 caracteres.",
    max: "Por favor, introduzca un máximo de 10 caracteres."
  },
    iso_3: {
 required: "Por favor, introduzca el código ISO 3.",
    min: "Por favor, introduzca un mínimo de 2 caracteres.",
    max: "Por favor, introduzca un máximo de 10 caracteres."
  },

  //CityComponent addCity and editCity.
  city_name: {
    required: "Por favor, introduzca el nombre de la ciudad.",
    alpha_spaces: "Solo se permiten alfabetos y espacios.",
    min: "Por favor, introduzca un mínimo de 3 caracteres.",
    max: "Por favor ingrese un máximo de 15 caracteres."
  },
  city_latitude: {
    required: "Por favor ingrese City Latitude.",
    decimal: "Solo se permiten números. p.ej. 24312 or 24312.12"
  },
  city_longitude: {
    required: "Por favor, introduzca la longitud de la ciudad.",
    decimal: "Solo se permiten números. p.ej. 24312 or 24312.12"
  },
  country_id: {
    required: "Por favor seleccione país."
  },
  state_id: {
    required: "Por favor seleccione el estado."
  },

  //GenreComponent addGenre and editGenre.
  g_name: {
    required: "Por favor, introduzca género.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },

  //MoviesCategoriesComponent addMovieCategory and editMovieCategory.
  mc_name: {
    required: "Por favor, introduzca la categoría de la película.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },

  //RatingsComponent addRating and editRating.
  rating: {
    required: "Por favor, introduzca calificaciones.",
    regex: "Solo se permiten alfabetos, caracteres especiales y números.",
    min: "Por favor, introduzca un mínimo de 1 caractere.",
    max: "Por favor ingrese un máximo de 20 caracteres."
  },

  //UnitofMeasurementComponent addUnitOfMeasurement and editUnitOfMeasurement.
  uom: {
    required: "Por favor, introduzca la unidad de medida.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },
  shortform: {
    required: "Por favor, introduzca el formulario corto.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },
  formula: {
    required: "Por favor, introduzca la fórmula.",
    numeric: "Solo se permiten números."
  },
  desc: {
    required: "Por favor, introduzca la descripción.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },

  //WeekdayComponent editWeekday.
  wd_day: {
    required: "Por favor, entre semana.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },

  //SignageTypesComponent addSignageType editSignageType.
  st_name: {
    required: "Por favor, introduzca el tipo de señalización.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },

  //SignageURLComponents
  su_name: {
    required: "Ingrese el nombre de la URL de señalización."
  },

  //SeatReservationTypeComponent addSeatReservationType and editSeatReservationType.
  srt_name: {
    required: "Ingrese el tipo de reserva de asiento.",
    alpha_spaces: "Solo se permiten alfabetos y espacios.",
    min: "Por favor, introduzca un mínimo de 3 caracteres.",
    max: "Por favor ingrese un máximo de 15 caracteres."
  },

  //RefundReasonComponent addRefundReason and editRefundReason.
  rr_reason: {
    required: "Ingrese el motivo del reembolso.",
    alpha_spaces: "Solo se permiten alfabetos y espacios.",
    min: "Por favor, introduzca un mínimo de 3 caracteres.",
    max: "Por favor ingrese un máximo de 100 caracteres."
  },

  //PaymentModesComponent addPaymentMode and editPaymentMode.
  pm_payment_mode: {
    required: "Ingrese el modo de pago.",
    alpha_spaces: "Solo se permiten alfabetos y espacios.",
    min: "Por favor, introduzca un mínimo de 3 caracteres.",
    max: "Por favor ingrese un máximo de 15 caracteres."
  },

  //MovieFormatComponent addMovieFormat and editMovieFormat.
  mf_name: {
    required: "Por favor, introduzca el formato de película.",
    regex: "Ingrese el formato de película adecuado. p.ej. 4D o 4D max",
    min: "Por favor, introduzca un mínimo de 2 caracteres."
  },

  //LanguageComponent addLanguage and editLanguage.
  lang_name: {
    required: "Por favor, introduzca el idioma.",
    alpha_spaces: "Solo se permiten alfabetos y espacios.",
    min: "Por favor, introduzca un mínimo de 3 caracteres."
  },

  //ImageSettingComponent addImageSetting and editImageSetting.
  image_setting_name: {
    required: "Por favor, introduzca el nombre de configuración de imagen.",
    alpha_spaces: "Solo se permiten alfabetos y espacios.",
    min: "Por favor, introduzca un mínimo de 3 caracteres."
  },
  image_setting_height: {
    required: "Por favor, introduzca la altura.",
    numeric: "Solo se permiten números."
  },
  image_setting_width: {
    required: "Por favor, introduzca el ancho.",
    numeric: "Solo se permiten números."
  },
  image_setting_ratio: {
    required: "Por favor ingrese Ratio.",
    numeric: "Solo se permiten números."
  },

  //HardwaresComponent addHardware and editHardware.
  h_name: {
    required: "Por favor, introduzca el nombre del hardware.",
    alpha_spaces: "Solo se permiten alfabetos y espacios.",
    min: "Por favor, introduzca un mínimo de 3 caracteres."
  },

  //CurrencyComponent addCurrency and editCurrency.
  curr_name: {
    required: "Por favor, introduzca el nombre de la moneda.",
    alpha_spaces: "Solo se permiten alfabetos y espacios.",
    min: "Por favor, introduzca un mínimo de 3 caracteres.",
    max: "Por favor, introduzca un máximo de 25 caracteres."
  },
  curr_code: {
    required: "Por favor, introduzca el código de moneda.",
    alpha: "Solo se permiten alfabetos.",
    min: "Por favor, introduzca un mínimo de 2 caracteres.",
    max: "Por favor, introduzca un máximo de 4 caracteres."
  },

  //CrewComponent addCrew and editCrew.
  crew_title: {
    required: "Por favor, introduzca el nombre de la tripulación.",
    alpha_spaces: "Solo se permiten alfabetos y espacios.",
    min: "Por favor, introduzca un mínimo de 3 caracteres."
  },

  //ChargeTypeComponent addChargeType and editChargeType.
  ct_name: {
    required: "Por favor, introduzca el tipo de carga.",
    alpha_spaces: "Solo se permiten alfabetos y espacios.",
    min: "Por favor, introduzca un mínimo de 3 caracteres."
  },
  ct_code: {
    required: "Ingrese el código de tipo de cargo.",
    alpha_dash: "Solo se permiten alfabetos, guiones y guiones bajos."
  },

  //BookingUserCategoriesComponent addBookingUserCategories and editBookingUserCategories.
  buc_category_name: {
    required: "Ingrese la categoría de usuario de reserva.",
    alpha_spaces: "Solo se permiten alfabetos y espacios.",
    min: "Por favor, introduzca un mínimo de 3 caracteres."
  },

  //BookingSourcesComponent addBookingSources and editBookingSources.
  bs_source: {
    required: "Por favor, introduzca la fuente de reserva.",
    alpha_spaces: "Solo se permiten alfabetos y espacios.",
    min: "Por favor, introduzca un mínimo de 3 caracteres."
  },

  //BackupSettingComponent addBackupSetting and editBackupSetting.
  selectcinema: {
    required: "Por favor seleccione cine."
  },
  fileselector: {
    required: "Por favor seleccione la ubicación de respaldo."
  },
  daily: {
    required: "Por favor, introduzca la hora diaria.",
    numeric: "Solo se permiten números."
  },
  selectday: {
    required: "Por favor seleccione el día."
  },
  weeklyin: {
    required: "Por favor, introduzca el tiempo semanal."
  },
  fortnight_1: {
    required: "Por favor, seleccione la fecha de inicio."
  },
  fortnight_2: {
    required: "Por favor, seleccione la fecha de finalización."
  },
  fortnight_3: {
    required: "Por favor, seleccione Hora de inicio."
  },
  fortnight_4: {
    required: "Por favor, seleccione Hora de finalización."
  },
  monthly_1: {
    required: "Por favor, seleccione Fecha mensual."
  },
  monthly_2: {
    required: "Por favor seleccione tiempo mensual."
  },

  //DenominationsComponent addDenomination and editDenomination.
  select_country: {
    required: "Por favor seleccione país."
  },
  select_currency: {
    required: "Por favor seleccione moneda."
  },
  denomination_val: {
    required: "Por favor, introduzca el valor de la denominación.",
    decimal: "Solo se permiten números. e.g. 10:25 OR 10"
  },

  //FeaturesComponent addFeature and editFeature.
  feature_name: {
    required: "Por favor, introduzca el nombre de la función.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },
  module_id: {
    required: "Por favor, seleccione el módulo."
  },
  feature_routes: {
    required: "Por favor, introduzca rutas / ruta."
  },

  //ModulesComponent addModule and editModule.
  module_name: {
    required: "Por favor, introduzca el nombre del módulo.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },

  //ModulesComponent addModule and editModule.
  module_name: {
    required: "Please enter Module Name.",
    alpha_spaces: "Only Alphabets and Spaces are allowed."
  },

  //OrganizationsComponent addOrganization and editOrganization.
  org_name: {
    required: "Por favor, introduzca el nombre de la organización.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },
  org_logo_url: {
    required: "Ingrese la URL del logotipo de la organización."
  },
  org_address: {
    required: "Por favor, introduzca la dirección de la organización.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },
  org_no_of_cinemas: {
    required: "Por favor, introduzca No de cine.",
    numeric: "Solo se permiten números."
  },
  org_pincode: {
    required: "Por favor, introduzca el código PIN.",
    numeric: "Solo se permiten números."
  },
  country_id: {
    required: "Por favor seleccione país."
  },
  state_id: {
    required: "Por favor seleccione el estado."
  },
  city_id: {
    required: "Por favor seleccione ciudad."
  },
  org_contact_no: {
    required: "Por favor, introduzca el número de contacto.",
    numeric: "Solo se permiten números."
  },
  org_setup_date: {
    required: "Seleccione la fecha de configuración."
  },
  org_launch_date: {
    required: "Por favor seleccione la fecha de lanzamiento."
  },

  //ProductionCompanyComponent addProductionCompany and editProductionCompany.
  production_name: {
    required: "Por favor, introduzca el nombre de la compañía de producción.",
    regex: "Solo se permiten alfabetos, números, espacios y guiones.",
    min: "Por favor ingrese un mínimo de 3 caracteres.",
    max: "Por favor, introduzca un máximo de 50 caracteres."
  },

  //StatuesComponent addStatues and editStatues.
  s_status_code: {
    required: "Por favor, introduzca el código de estatuas.",
    "alpha_dash ":
      "Solo se permiten alfabetos, guiones, guiones bajos y números."
  },
  s_status_display: {
    required: "Por favor, introduzca el nombre para mostrar estatuas.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },

  //DistributorShateTypeComponent addDistributorShareType and editDistributorShareType
  sharelabel: {
    required: "Ingrese Compartir etiqueta.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },

  //DistributorShareComponent distributor
  selectmovie_1: {
    required: "Por favor seleccione película."
  },
  selectmovie_2: {
    required: "Por favor seleccione película."
  },
  selectcinema_1: {
    required: "Por favor seleccione cine."
  },
  selectfromdate: {
    required: "Por favor seleccione desde la fecha."
  },
  selectenddate: {
    required: "Por favor, seleccione la fecha de finalización."
  },

  //DistributorContractComponent addDistributorContract
  selectcine_1: {
    required: "Por favor seleccione cine."
  },
  selectmovie_1: {
    required: "Por favor seleccione película."
  },
  selectdistri_1: {
    required: "Por favor seleccione distribuidor."
  },
  selectfromdate_1: {
    required: "Por favor seleccione desde la fecha."
  },
  selectenddate_1: {
    required: "Por favor, seleccione la fecha de finalización."
  },
  selectdistrisharetype: {
    required: "Seleccione el tipo de participación del distribuidor."
  },
  sharevalue_1: {
    required: "Por favor seleccione Compartir valor.",
    numeric: "Solo se permiten números."
  },

  //ShiftsComponent addShift and editShift
  shift_name: {
    required: "Por favor, introduzca el nombre del turno.",
    regex: "Solo se permiten alfabetos y espacios."
  },
  shift_working_hrs: {
    required: "Ingrese las horas de trabajo por turnos.",
    regex: "Solo se permiten alfabetos, números, espacios y dos puntos."
  },
  shift_start_time: {
    required: "Ingrese la hora de inicio de turno.",
    regex: "Solo se permiten alfabetos, números, espacios y dos puntos."
  },
  shift_end_time: {
    required: "Ingrese la hora de finalización del turno.",
    regex: "Solo se permiten alfabetos, números, espacios y dos puntos."
  },

  //UserShiftsComponent addUserShift and editUserShift
  "selectcinema-1": {
    required: "Por favor seleccione cine."
  },
  selectuser: {
    required: "Por favor seleccione usuario."
  },
  selectshift: {
    required: "Por favor seleccione Shift."
  },
  "shiftstart-1": {
    required: "Seleccione Fecha de inicio de turno."
  },
  "shiftend-1": {
    required: "Seleccione Fecha de finalización de turno."
  },

  //CinemasComponent addCinemas and editCinemas
  cine_name: {
    required: "Por favor, introduzca el nombre del cine.",
    min: "Por favor, introduzca un mínimo de 3 caracteres.",
    max: "Por favor, introduzca un máximo de 50 caracteres."
  },
  cine_code: {
    required: "Por favor, introduzca el código de cine.",
    alpha_num: "Solo se permiten alfabetos y números."
  },
  org: {
    required: "Por favor seleccione organización."
  },
  cine_location: {
    required: "Por favor, introduzca la ubicación.",
    alpha_spaces: "Solo se permiten alfabetos y espacios.",
    min: "Por favor ingrese un mínimo de 3 caracteres.",
    max: "Por favor, introduzca un máximo de 50 caracteres."
  },
  cine_address: {
    required: "Por favor, introduzca la dirección.",
    min: "Por favor ingrese un mínimo de 3 caracteres.",
    max: "Por favor, introduzca un máximo de 255 caracteres."
  },
  cine_pincode: {
    required: "Por favor, introduzca el código PIN.",
    numeric: "Solo se permiten números.",
    alpha_num: "Solo se permiten números y alfabetos.",
    min: "Por favor, introduzca un mínimo de 6 caracteres.",
    max: "Por favor ingrese un máximo de 6 caracteres."
  },
  curr: {
    required: "Por favor seleccione moneda."
  },
  coun: {
    required: "Por favor seleccione país."
  },
  state: {
    required: "Por favor seleccione el estado."
  },
  city: {
    required: "Por favor seleccione ciudad."
  },
  cine_phone: {
    required: "Por favor, introduzca el número de teléfono.",
    numeric: "Solo se permiten números.",
    min: "Por favor, introduzca un mínimo de 6 números.",
    max: "Por favor ingrese un máximo de 12 números."
  },
  cine_email: {
    required: "Por favor, introduzca su ID de correo electrónico.",
    email: "Ingrese la ID de correo electrónico correcta."
  },
  cine_screens: {
    required: "Por favor, introduzca el número de pantalla.",
    numeric: "Solo se permiten números.",
    max: "Por favor ingrese un máximo de 2 caracteres."
  },
  cine_latitude: {
    required: "Por favor, introduzca Latitude.",
    decimal: "Solo se permiten números. p.ej. 24312 or 24312.12"
  },
  cine_longitude: {
    required: "Por favor, introduzca longitud.",
    decimal: "Solo se permiten números. p.ej. 24312 or 24312.12"
  },
  cine_booking_cut_off_time: {
    required: "Ingrese el tiempo de corte.",
    max: "Por favor ingrese un máximo de 10 caracteres."
  },
  cine_license_number: {
    required: "Por favor, introduzca el número de licencia.",
    alpha_num: "Solo se permiten alfabetos y números.",
    min: "Por favor, introduzca un mínimo de 5 caracteres.",
    max: "Por favor ingrese un máximo de 30 caracteres."
  },
  cine_registration_number: {
    required: "Por favor, introduzca el número de registro.",
    alpha_num: "Solo se permiten alfabetos y números.",
    min: "Por favor, introduzca un mínimo de 5 caracteres.",
    max: "Por favor ingrese un máximo de 30 caracteres."
  },
  cine_operations_start_time: {
    required: "Ingrese la hora de inicio de la operación.",
    max: "Por favor ingrese un máximo de 10 caracteres."
  },
  cine_operations_end_time: {
    required: "Ingrese la hora de finalización de la operación.",
    max: "Por favor ingrese un máximo de 10 caracteres."
  },
  cine_concession_level: {
    required: "Ingrese el nivel de concesión de cine.",
    min: "Por favor ingrese un mínimo de 3 caracteres.",
    max: "Por favor, introduzca un máximo de 50 caracteres."
  },
  cine_image_url: {
    required: "Por favor sube la imagen."
  },

  //CinemasScreensComponent addCinemasScreen and editCinemasScreen
  screen_name: {
    required: "Por favor, introduzca el nombre de pantalla.",
    regex: "Solo se permiten alfabetos, números y espacios.",
    min: "Por favor ingrese un mínimo de 3 caracteres.",
    max: "Por favor ingrese un máximo de 15 caracteres."
  },
  screen_no_of_seats: {
    required: "Por favor, introduzca el número de asientos.",
    numeric: "Solo se permiten números."
  },
  screen_no_of_cols: {
    required: "Por favor, introduzca el número de columnas.",
    numeric: "Solo se permiten números."
  },
  screen_no_of_rows: {
    required: "Por favor, introduzca el número de filas.",
    numeric: "Solo se permiten números."
  },

  //SeatTypeComponent addSeatType and editSeatType
  seattype: {
    required: "Por favor, introduzca el tipo de asiento.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },
  seatno: {
    required: "Por favor, introduzca el número de asientos.",
    numeric: "Solo se permiten números."
  },

  //RateCardComponent addRateCard and editRateCard
  ratename: {
    required: "Por favor, introduzca el nombre de la hoja de tarifas.",
    regex: "Solo se permiten alfabetos y números."
  },
  rateamount: {
    required: "Por favor ingrese el monto de la tarifa",
    regex: "Solo se permiten números. p.ej. 100.25 o 100"
  },

  //ChargeSettingComponent addChargeSetting and editChargeSetting
  chargesetting: {
    required: "Ingrese el Nombre de configuración de carga.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },
  chargevalue: {
    required: "Por favor, introduzca el valor del cargo.",
    numeric: "Solo se permiten números."
  },
  fd: {
    required: "Por favor seleccione desde la fecha."
  },
  td: {
    required: "Por favor seleccione hasta la fecha."
  },

  //FloatAmountComponent addFloatAmount and editFloatAmount
  floatamount: {
    required: "Por favor, introduzca el valor del cargo.",
    numeric: "Solo se permiten números."
  },

  //AggregatorsComponent addAggregator and editAggregator
  aggregator_name: {
    required: "Por favor, introduzca el nombre del agregador.",
    alpha_spaces: "Solo se permiten alfabetos y espacios.",
    min: "Por favor, introduzca un mínimo de 3 caracteres.",
    max: "Por favor ingrese un máximo de 15 caracteres."
  },
  contract_start_date: {
    required: "Seleccione la fecha de inicio del contrato."
  },
  contract_end_date: {
    required: "Seleccione la fecha de finalización del contrato."
  },
  aggregator_api_id: {
    required: "Por favor, introduzca la ID de la API.",
    alpha_num: "Solo se permiten alfabetos y números.",
    min: "Por favor, introduzca un mínimo de 3 caracteres.",
    max: "Por favor, introduzca un máximo de 50 caracteres."
  },
  aggregator_authentication_code: {
    required: "Por favor, introduzca el código de autenticación.",
    numeric: "Solo se permiten números."
  },
  aggregator_username: {
    required: "Por favor, introduzca el nombre de usuario.",
    alpha_num: "Solo se permiten alfabetos y números."
  },
  aggregator_password: {
    required: "Por favor, ingrese contraseña.",
    alpha_num: "Solo se permiten alfabetos y números."
  },

  //HardwareSettingsComponent addHardwareSetting and editHardwareSetting
  uname: {
    required: "Por favor, introduzca el nombre de usuario."
    // "alpha_num": "Solo se permiten alfabetos y números."
  },
  pwd: {
    required: "Por favor, ingrese contraseña.",
    regex:
      "La contraseña debe contener un mínimo de 8 y un máximo de 16 caracteres. Contiene al menos una letra minúscula, una letra mayúscula y un carácter especial."
  },
  ucode: {
    required: "Ingrese el código único de hardware."
    // "alpha_num": "Solo se permiten alfabetos y números."
  },
  hardwarename: {
    required: "Por favor, introduzca el nombre del hardware.",
    regex: "Only Alphabets, Numbers and Spaces are allowed."
  },
  hardwareremark: {
    required: "Por favor, introduzca notas / comentarios de hardware.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },
  hardwareport: {
    required: "Ingrese el puerto de conexión de hardware.",
    numeric: "Solo se permiten números."
  },
  hardwareinstall: {
    required: "Ingrese el hardware 'Instalar por'.",
    alpha_spaces: "Se permiten alfabetos y espacios."
  },

  //RawMaterialComponent addRawMaterial and editRawMaterial
  rawmaterial: {
    required: "Please enter Raw Material Name."
  },
  quantity: {
    required: "Please enter Quantity Alert.",
    numeric: "Only Numbers are allowed."
  },
  uomdropdown: {
    required: "Please Select Unit of Measurement."
  },

  //ItemCostPriceComponent addItemCostPrice and editItemCostPrice
  costprice: {
    required: "Por favor, introduzca el precio de coste.",
    decimal: "Solo se permiten números. p.ej. 100 o 100.25"
  },

  //OTP (Forgot Password)
  otpnumber: {
    required: "Por favor, introduzca OTP."
  },

  //Password & Confirm Password
  forgotpassword: {
    required: "Por favor, ingrese contraseña.",
    regex:
      "La contraseña debe contener un mínimo de 8 y un máximo de 16 caracteres. Contiene al menos una letra minúscula, una letra mayúscula y un carácter especial."
  },
  forgotconfirm: {
    required: "Por favor, ingrese Confirmar contraseña.",
    confirmed: "Confirme que la contraseña no coincide."
  },

  //CinemaSettingComponent addCinemaSetting and editCinemaSetting
  concessionlevel: {
    required: "Ingrese el nombre de la configuración de cine.",
    max: "Por favor ingrese un máximo de 30 caracteres."
  },
  operationstime: {
    required: "Ingrese la hora de inicio de la negocio.",
    regex: "Solo se permiten números. p.ej. 23:00 or 23"
  },
  operationetime: {
    required: "Ingrese la hora de finalización de la negocio.",
    regex: "Solo se permiten números. p.ej. 23:00 or 23"
  },
  cleaningtime: {
    required: "Por favor, introduzca el tiempo de limpieza.",
    numeric: "Solo se permiten números."
  },
  settingadstime: {
    required: "Por favor, introduzca el tiempo de publicidad.",
    numeric: "Solo se permiten números."
  },
  intervaltime: {
    required: "Por favor, introduzca el tiempo de intervalo.",
    numeric: "Solo se permiten números."
  },
  mycinema_creation_interval_time: {
    numeric: "Solo se permiten números."
  },
  releasetime: {
    required: "Por favor, introduzca el tiempo de lanzamiento.",
    numeric: "Only Numbers are allowed."
  },
  cutofftime: {
    required: "ngrese el tiempo de corte.",
    numeric: "Solo se permiten números."
  },
  ipaddress: {
    required: "Ingrese el rango de dirección IP.",
    decimal: "Solo se permiten números decimales, puntos y asteriscos."
  },

  //DistributorsComponent
  d_company_name: {
    required: "Por favor, introduzca el nombre del distribuidor.",
    min: "Por favor, introduzca un mínimo de 3 caracteres."
  },
  d_sister_company: {
    required: "Ingrese el nombre de la empresa hermana."
  },
  d_contact_no: {
    required: "Por favor, introduzca el número de contacto.",
    numeric: "Solo se permiten números.",
    min: "Por favor, introduzca un mínimo de 6 números.",
    max: "Por favor, introduzca un máximo de 15 números."
  },
  d_email_id: {
    required: "Por favor ingrese su ID de correo electrónico.",
    email:
      "Por favor, introduzca la identificación de correo electrónico correcta."
  },
  d_tin_number: {
    required: "Por favor, introduzca el número TIN.",
    alpha_num: "Solo se permiten alfabetos y números."
  },
  d_tax_number: {
    required: "Por favor, introduzca el número de impuesto.",
    alpha_num: "Solo se permiten alfabetos y números."
  },
  d_tax_type: {
    required: "Por favor, introduzca el tipo de impuesto.",
    alpha_num: "Solo se permiten alfabetos y números."
  },
  d_address: {
    required: "Por favor, introduzca la dirección."
  },

  //RateCardComponent addRateCard and editRateCard
  cardname: {
    required: "Por favor, introduzca el nombre de la hoja de tarifas.",
    regex: "Solo se permiten alfabetos y números."
  },
  cardamount: {
    required: "Por favor seleccione cantidad.",
    regex: "Solo se permiten números. Por ejemplo, 100.00 o 100"
  },

  //FnBPricingComponent addFnBPricing and editFnBPricing
  netamount: {
    required: "Por favor ingrese el monto neto.",
    regex: "Solo se permiten números. p.ej. 100.25"
  },
  tamount: {
    required: "Por favor, introduzca la cantidad total.",
    regex: "Solo se permiten números. p.ej. 100.25"
  },
  fdate1: {
    required: "Por favor seleccione desde la fecha."
  },
  tdate1: {
    required: "Por favor seleccione hasta la fecha."
  },

  //Renunciation
  renunciationremark: {
    required: "Por favor, introduzca la razón de la partida."
  },
  dateleaving: {
    required: "Por favor, seleccione la fecha de salida."
  },
  //Concession
  concession_name: {
    required: "Por favor, introduzca el nombre de la concesión."
  },
  concession_pos: {
    required: "Por favor ingrese el No. de POS.",
    numeric: "Solo se permiten números."
  },
  concession_kiosk: {
    required: "Por favor, introduzca el número de quiosco",
    numeric: "Solo se permiten números."
  },
  concession_signage: {
    required: "Por favor, introduzca el número de señalización.",
    numeric: "Solo se permiten números."
  },
  concession_counter: {
    required: "Ingrese el número de mostrador de F&B",
    numeric: "Solo se permiten números."
  },

  //Change Password
  currentpass: {
    required: "Por favor, introduzca la contraseña actual."
  },

  //Reserve Seats
  showdate: {
    required: "Por favor, seleccione la fecha de presentación."
  },

  //Templates
  template_name: {
    required: "Por favor, introduzca el nombre de la plantilla."
  },

  //FnBitemComponent addFnBitem and editFnBitem
  itemcode: {
    required: "Por favor, introduzca el código del artículo.",
    alpha_num: "Solo se permiten números y alfabéticos."
  },
  itemname: {
    required: "Por favor, introduzca el nombre del artículo."
  },
  "file-selector3": {
    required: "Seleccione Archivo de imagen de alimentos."
  },
  delete_reason: {
    required: "Por favor, introduzca la razón para eliminar Mostrar."
  },

  //GlobalLoyaltySettings Componets
  loyaltysettingname: {
    required: "Ingrese el nombre de la configuración de lealtad global"
  },
  initialload: {
    required: "Por favor ingrese el monto inicial"
  },
  expiryvalue: {
    required: "Por favor, introduzca el valor de vencimiento"
  },
  loyaltylevelname: {
    required: "Ingrese el nombre del nivel de lealtad"
  },
  pointrquired: {
    required: "Por favor ingrese los puntos requeridos"
  },
  bonuspoint: {
    required: "Por favor, introduzca puntos de bonificación"
  },

  //LoyaltySettings Components
  cinemaloyaltyname: {
    required: "Por favor, introduzca el nombre de configuración de lealtad"
  },
  selectcinema: {
    required: "Por favor seleccione Cine"
  },
  minimumreedempoints: {
    required: "Ingrese los puntos mínimos para canjear"
  },
  maximumreedempoints: {
    required: "Ingrese el máximo de puntos para canjear"
  },
  minimumpointearning: {
    required: "Por favor ingrese los puntos mínimos ganados"
  },
  maximumpointearning: {
    required: "Please enter Maximum points earning"
  },
  eligibilitytoenroll: {
    required: "Por favor ingrese a Eligiblity para inscribirse"
  },

  earnboxofficeratio: {
    required: "Ingrese el índice de taquilla para ganar puntos"
  },
  earnfnbratio: {
    required: "Ingrese la relación de alimentos y bebidas para ganar puntos"
  },
  burnboxofficeratio: {
    required: "Ingrese el índice de taquilla para puntos de quemado"
  },
  burnfnbratio: {
    required:
      "Ingrese el índice de alimentos y bebidas para los puntos de consumo"
  },

  //EmailTemplate Components
  emailtemplatename: {
    required:
      "Por favor, introduzca el nombre de la plantilla de correo electrónico"
  },
  emailtitle: {
    required: "Por favor, introduzca el nombre del correo electrónico"
  },
  emaildesc: {
    required: "Por favor, introduzca el contenido del correo electrónico."
  },

  //SendEmail in Listemailtemplate
  toemail: {
    required: "Por favor, envíe un correo electrónico",
    email: "Por favor ingrese la dirección de correo electrónico correcta"
  },

  //SMSTemplate Components
  smstemplatename: {
    required: "Por favor, introduzca el nombre de la plantilla de SMS"
  },
  smstext: {
    required: "Por favor ingrese el texto"
  },

  //Support Ticket Category
  category_name: {
    required: "Por favor, introduzca el nombre de la categoría."
  },

  //Support Ticket
  subject: {
    required: "Por favor, introduzca el asunto."
  },
  description: {
    required: "Por favor, introduzca la descripción."
  },

  //checklist category
  category_description: { required: "Por favor, introduzca la descripción." },

  //checklist
  checklist_name: {
    required: "Por favor, introduzca el nombre de la lista de verificación."
  },
  selected_category: {
    required: "Seleccione la categoría Lista de verificación."
  },
  selected_cinema: {
    required: "Por favor seleccione Cine"
  },

  //Add & Edit Banners
  banner_name: {
    required: "Por favor, introduzca el nombre del banner."
  },
  banner_header: {
    required: "Por favor, introduzca el encabezado del banner."
  },
  banner_subheader: {
    required: "Por favor, ingrese el encabezado del encabezado."
  },
  banner_description: {
    required: "Por favor, introduzca la descripción del banner."
  },

  //PosBooking
  card_number: {
    numeric: "Por favor ingrese solo números",
    min: "Por favor ingrese un mínimo de 12 dígitos",
    max: "Por favor ingrese un máximo de 12 dígitos"
  },

  //Cash Card
  "Cantidad inicial": {
    obligatorio: "Ingrese la cantidad",
    numeric: "Ingrese solo números"
  },
  //Feedback Form Components
  form_name: {
    required: "Por favor, introduzca el nombre del formulario.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },
  form_description: {
    required: "Por favor, introduzca la descripción del formulario."
  },
  form_field: {
    required: "Por favor, introduzca el campo del formulario."
    // "alpha_spaces": "Solo se permiten alfabetos y espacios."
  },
  min_length: {
    required: "Por favor, introduzca la longitud mínima.",
    numeric: "Solo se permiten números."
  },
  max_length: {
    required: "Por favor, introduzca la longitud máxima.",
    numeric: "Solo se permiten números."
  },
  //FnBDynamicPricing
  pricing_name: {
    required: "Por favor, introduzca el nombre del precio.",
    regex: "Solo se permiten alfabetos, espacios y números."
  },
  new_item_price: {
    required: "Ingrese el precio neto del nuevo artículo.",
    decimal: "Solo se permiten números, por ejemplo, 100.50 o 100."
  },
  //Add-ons
  addon_item_name: {
    required: "Ingrese el nombre del elemento adicional.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },
  max_qty: {
    required: "Por favor, introduzca la cantidad máxima.",
    decimal: "Solo se permiten números, por ejemplo, 100.50 o 100."
  },
  addon_item_price: {
    required: "Por favor, introduzca el precio del artículo.",
    decimal: "Solo se permiten números, por ejemplo, 100.50 o 100."
  },
  //Cinema types
  cinema_type_name: {
    required: "Por favor, introduzca el nombre del tipo de cine.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },
  //Tier types
  tier_type_name: {
    required: "Por favor, introduzca el nombre del tipo de nivel.",
    regex: "Solo se permiten alfabetos, números y espacios."
  },
  //Weekwise Contract
  weekwise_name: {
    required: "Por favor ingrese el nombre del contrato de la semana.",
    regex: "Solo se permiten alfabetos, espacios y números."
  },
  //Sound Format
  sound_format_name: {
    required: "Por favor, introduzca el nombre del formato de sonido."
  },
  //Store Management
  sm_store_name: {
    required: "Por favor, introduzca el nombre de la tienda.",
    regex: "Solo se permiten alfabetos, espacios y números."
  },
  sm_store_slug: {
    required: "Por favor, introduzca la babosa de la tienda.",
    regex: "Solo se permiten alfabetos, espacios y números."
  },
  //Transfer Stock
  transfer_qty: {
    required: "Por favor, introduzca la cantidad.",
    numeric: "Solo se permiten números."
  },
  adjustment_rate: {
    required: "Please enter rate per item",
    numeric: "Only numbers are allowed."
  },
  adjustment_tax: {
    required: "Please total Tax",
    numeric: "Only numbers are allowed."
  },

  //FnB wastage
  wastage_qty: {
    required: "Por favor ingrese la cantidad.",
    numeric: "Solo se permiten números."
  },
  fineamount: {
    required: "Por favor ingrese el monto total.",
    decimal: "Solo se permiten números. p.ej. 100 o 100,25",
    max: "Ingrese un máximo de 5 números."
  },
  remark: {
    required: "Por favor ingrese el comentario."
  },

  //Promotion and Offers
  offer_title: {
    required: "Por favor, introduzca el título de la oferta."
  },
  share_value: {
    required: "Por favor, introduzca el valor de la acción.",
    decimal: "Solo se permiten números. p.ej. 100.50 O 100"
  },
  buy_value: {
    required: 'Por favor, introduzca el valor "Comprar".',
    numeric: "Only numbers are allowed."
  },
  get_value: {
    required: 'Por favor, introduzca el valor "Obtener".',
    numeric: "Only numbers are allowed."
  },
  min_ticket_amount: {
    required: "Por favor ingrese el monto mínimo del boleto.",
    decimal: "Solo se permiten números. p.ej. 100.50 O 100"
  },
  max_ticket: {
    required: "Ingrese el boleto gratuito máximo por transacción.",
    numeric: "Solo se permiten números."
  },
  discount_buy_value: {
    required: 'Por favor, introduzca el valor "Comprar".',
    numeric: "Solo se permiten números."
  },
  discount_get_value: {
    required: 'Ingrese el valor "obtener descuento de".',
    numeric: "Solo se permiten números."
  },
  max_discount_per_trans: {
    required: "Ingrese el descuento máximo por transacción.",
    numeric: "Solo se permiten números."
  },
  buy_fnb_combo: {
    required: 'Ingrese el valor "Comprar" para F&B.',
    numeric: "Solo se permiten números."
  },
  get_fnb_combo: {
    required: 'Ingrese el valor "Obtener" para F&B.',
    numeric: "Solo se permiten números."
  },
  free_combo_offer_value: {
    required: "Por favor, introduzca el valor de la oferta.",
    decimal: "Solo se permiten números. p.ej. 100.50 O 100"
  },
  buy_bo_combo: {
    required: 'Ingrese el valor "Comprar" para la taquilla.',
    numeric: "Solo se permiten números."
  },
  free_combo_bo_offer_value: {
    required: "Por favor, introduzca el valor de la oferta.",
    decimal: "Solo se permiten números. p.ej. 100.50 O 100"
  },
  customer_min_ticket_amount: {
    required: "Por favor ingrese el monto mínimo del boleto.",
    decimal: "Solo se permiten números. p.ej. 100.50 O 100"
  },
  customer_max_discount_per_trans: {
    required: "Ingrese el descuento máximo por transacción.",
    numeric: "Solo se permiten números."
  },
  customer_offer_value: {
    required: "Por favor, introduzca el precio de oferta.",
    decimal: "Solo se permiten números. p.ej. 100.50 O 100"
  },
  bank_redemption_count: {
    required: "Ingrese el recuento de canjes.",
    numeric: "Solo se permiten números."
  },
  bank_max_redemption_per_user: {
    required: "Ingrese el canje máximo por usuario.",
    numeric: "Solo se permiten números."
  },
  bank_offer_value: {
    required: "Por favor, introduzca el precio de oferta.",
    decimal: "Solo se permiten números. p.ej. 100.50 O 100"
  },
  promo_code: {
    required: "Por favor, introduzca el código de promoción.",
    alpha_num: "Only alphabets and numbers are allowed."
  },
  applicalbe_for: {
    required: "Por favor ingrese no. de transacción.",
    numeric: "Solo se permiten números."
  },
  promo_min_ticket_amount: {
    required: "Por favor ingrese el monto mínimo del boleto.",
    decimal: "Solo se permiten números. p.ej. 100.50 O 100"
  },
  promo_max_discount_per_user: {
    required: "Ingrese el descuento máximo por transacción.",
    numeric: "Solo se permiten números."
  },
  promo_offer_value: {
    required: "Por favor, introduzca el precio de oferta.",
    decimal: "Solo se permiten números. p.ej. 100.50 O 100"
  },

  //Create New Password PIN
  passwordpin: {
    required: "Por favor, introduzca una nueva contraseña.",
    numeric: "Solo se permiten números.",
    min: "Por favor ingrese un mínimo de 4 números.",
    max: "Por favor ingrese un máximo de 8 números."
  },
  confirm_password: {
    required: "Por favor, ingrese Confirmar contraseña.",
    confirmed: "Confirme que la contraseña no coincide."
  },

  //Customer
  cust_email: {
    required: "Por favor, introduzca el correo electrónico del cliente.",
    email: "Por favor, introduzca la dirección de correo electrónico correcta."
  },

  //VendorComponent addVendor and editVendor
  vendorname: {
    required: "Por favor, introduzca el nombre del vendedor.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },
  vendornumber: {
    // "required": "Please enter Vendors TIN Number.",
    alpha_num: "Solo se permiten números y alfabetos.",
    min: "Por favor ingrese un mínimo de 3 caracteres.",
    max: "Por favor, introduzca un máximo de 11 caracteres."
  },
  vendortax: {
    // "required": "Please enter Vendors Tax Number.",
    alpha_num: "Solo se permiten alfabetos y números.",
    min: "Por favor ingrese un mínimo de 3 caracteres.",
    max: "Por favor ingrese un máximo de 15 caracteres."
  },
  taxtype: {
    required: "Ingrese el tipo de impuesto de proveedor.",
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },
  vendoraddress: {
    required: "Ingrese la dirección del proveedor."
    // "alpha_spaces": "Only Alphabets and Spaces are allowed."
  },
  vendorno: {
    required: "Por favor, introduzca el número de contacto.",
    numeric: "Solo se permiten números.",
    min: "Por favor, introduzca un mínimo de 6 caracteres.",
    max: "Por favor, introduzca un máximo de 10 caracteres."
  },
  vendoremail: {
    required: "Por favor, introduzca su dirección de correo electrónico.",
    email: "Por favor, introduzca la dirección de correo electrónico correcta."
  },

  //Create GRN
  expirydate: {
    required: "Por favor seleccione la fecha de vencimiento."
  },
  invoicenumber: {
    required: "Por favor, introduzca el número de factura.",
    alpha_num: "Solo se permiten alfabetos y números."
  },
  invoicedate: {
    required: "Por favor seleccione la fecha de la factura."
  },
  stockquantity: {
    required: "Por favor, introduzca stock en cantidad.",
    numeric: "Solo se permiten números."
  },
  batchnumber: {
    required: "Por favor, introduzca el número de lote.",
    alpha_num: "Solo se permiten alfabetos y números."
  },

  //Client Component
  client_name: {
    required: "Ingrese el nombre del cliente."
  },
  client_contact_person_name: {
    alpha_spaces: "Solo se permiten alfabetos y espacios."
  },
  client_contact_person_email_id: {
    email: "Ingrese el ID de correo electrónico correcto."
  },
  client_contact_person_mobile_number: {
    numeric: "Solo se permiten números.",
    min: "Ingrese un mínimo de 7 dígitos."
  },

  //Good Return
  fgr_remarks: {
    required: "Por favor ingrese comentarios"
  },

  //SMS Template
  sms_contact_no: {
    required: "Ingrese el número de contacto.",
    numeric: "Solo se permiten números.",
    max: "Ingrese un máximo de 16 números."
  }
};



// WEBPACK FOOTER //
// ./src/errorHandler/ln/es.js